import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ModalService2 } from 'src/app/services/modal2.service';

@Component({
    selector: 'modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ModalComponent {
    @Input() confirmText: string = 'Ok';
    @Input() cancelText: string|undefined;
    @Input() confirmBlocked: boolean = false;
    @Input() cancelBlocked: boolean = false;
    @Input() showCloseIcon = true;
    @Input() minHeight: string = '20rem';

    constructor(private modalService: ModalService2) {}

    onClose(): void {
    	this.modalService.dismissLast();
    }

    onConfirm(): void {
    	this.modalService.closeLast('confirmed');
    }

    onCancel(): void {
    	this.modalService.closeLast('cancelled');
    }
}
